import React from "react";
import { Link } from "react-router-dom";
import gigifyLogo from '../../assets/Logo/GIGiFY Logo Horizontal with tagline.png';
import facebookIcon from '../../assets/Images/FacebookIcon.png';
import twitterIcon from '../../assets/Images/XTwitterIcon.png';
import instagramIcon from '../../assets/Images/InstagramIcon.png';
import linkedinIcon from '../../assets/Images/LinkedInIcon.png';

const MobileFooter = () => {
  // Container styles with CSS Grid
  const footerStyle = {
    position: "relative",
    width: "100%",
    minHeight: "150px",
    display: "grid",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto auto auto auto auto",
    gridTemplateAreas: `
      "logo"
      "nav"
      "social"
      "copyright"
    `,
    padding: "15px 20px 10px 20px",
    gap: "10px",
    overflow: "visible",
    fontFamily: "Montserrat, sans-serif",
    background: "transparent"
  };

  // Top border line - full width
  const topBorderStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    width: "100vw",
    height: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    zIndex: 4
  };

  // Logo area styles
  const logoAreaStyle = {
    gridArea: "logo",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    zIndex: 3
  };

  // Logo styles
  const logoStyle = {
    width: "240px",  // Scaled down from desktop's 400px for mobile
    height: "auto",
    maxWidth: "90%",
    objectFit: "contain",
    imageRendering: "-webkit-optimize-contrast",
    WebkitBackfaceVisibility: "hidden",
    transform: "translateZ(0)",
    margin: "0 auto 15px auto"  // Center horizontally with reduced bottom margin
  };

  // Navigation area styles
  const navAreaStyle = {
    gridArea: "nav",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    zIndex: 3
  };
  
  // Navigation container
  const navContainerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    fontSize: "14px",
    lineHeight: "1.5"
  };

  // Individual nav link style
  const navLinkStyle = {
    color: "rgba(255, 255, 255, 0.7)",  // Light grey like desktop footer
    textDecoration: "none",
    fontSize: "10px",
    fontWeight: "400",
    transition: "color 0.3s ease",
    whiteSpace: "nowrap"
  };

  // Divider style
  const dividerStyle = {
    width: "1px",
    height: "14px",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    margin: "0"
  };

  // Social area styles
  const socialAreaStyle = {
    gridArea: "social",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    position: "relative",
    zIndex: 3,
    paddingTop: "25px",
    marginBottom: "-15px"
  };
  
  // Social media container
  const socialContainerStyle = {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    alignItems: "center",
    justifyContent: "center"
  };

  // Social icon style with filter to change blue to orange
  const socialIconStyle = {
    width: "30px",
    height: "30px",
    filter: "brightness(0) saturate(100%) invert(38%) sepia(89%) saturate(2821%) hue-rotate(5deg) brightness(102%) contrast(96%)", // Converts to #f85008
    transition: "transform 0.3s ease",
    cursor: "pointer"
  };

  // Copyright area styles
  const copyrightAreaStyle = {
    gridArea: "copyright",
    position: "relative",
    zIndex: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: "8px",
    marginTop: "5px"
  };
  
  // Bottom border line - full width
  const bottomBorderStyle = {
    position: "absolute",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
    width: "100vw",
    height: "1px",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    zIndex: 4
  };

  // Copyright style
  const copyrightStyle = {
    color: "rgba(255, 255, 255, 0.7)",
    fontSize: "11px",
    fontWeight: "400",
    textAlign: "center"
  };

  return (
    <footer style={footerStyle}>
      {/* Top border - full width */}
      <div style={topBorderStyle}></div>
      
      {/* Logo Area */}
      <div style={logoAreaStyle}>
        <img src={gigifyLogo} alt="GIGiFY Logo" style={logoStyle} />
      </div>
      
      {/* Navigation Area */}
      <div style={navAreaStyle}>
        {/* Central vertical line */}
        <div style={{
          position: "absolute",
          width: "1px",
          height: "42px",
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)"
        }}></div>
        
        {/* Navigation container */}
        <div style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          position: "absolute"
        }}>
          {/* Left side nav items */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: "8px",
            paddingRight: "10px",
            marginLeft: "-120px"
          }}>
            <Link 
              to="/privacy-policy" 
              style={navLinkStyle}
              onTouchStart={(e) => e.target.style.color = "#f85008"}
              onTouchEnd={(e) => setTimeout(() => e.target.style.color = "rgba(255, 255, 255, 0.7)", 200)}
            >
              Privacy Policy
            </Link>
            <Link 
              to="/community-standards" 
              style={navLinkStyle}
              onTouchStart={(e) => e.target.style.color = "#f85008"}
              onTouchEnd={(e) => setTimeout(() => e.target.style.color = "rgba(255, 255, 255, 0.7)", 200)}
            >
              Community Standards
            </Link>
          </div>
          
          {/* Right side nav items */}
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "8px",
            paddingLeft: "10px",
            marginRight: "-130px"
          }}>
            <Link 
              to="/service-terms" 
              style={navLinkStyle}
              onTouchStart={(e) => e.target.style.color = "#f85008"}
              onTouchEnd={(e) => setTimeout(() => e.target.style.color = "rgba(255, 255, 255, 0.7)", 200)}
            >
              Terms of Service
            </Link>
            <Link 
              to="/performance-agreement" 
              style={navLinkStyle}
              onTouchStart={(e) => e.target.style.color = "#f85008"}
              onTouchEnd={(e) => setTimeout(() => e.target.style.color = "rgba(255, 255, 255, 0.7)", 200)}
            >
              Performance Agreement
            </Link>
          </div>
        </div>
      </div>
      
      {/* Social Area */}
      <div style={socialAreaStyle}>
        <div style={socialContainerStyle}>
          <a 
            href="https://linkedin.com" 
            target="_blank" 
            rel="noopener noreferrer"
            onMouseEnter={(e) => e.currentTarget.firstChild.style.transform = "scale(1.1)"}
            onMouseLeave={(e) => e.currentTarget.firstChild.style.transform = "scale(1)"}
          >
            <img src={linkedinIcon} alt="LinkedIn" style={socialIconStyle} />
          </a>
          <a 
            href="https://instagram.com" 
            target="_blank" 
            rel="noopener noreferrer"
            onMouseEnter={(e) => e.currentTarget.firstChild.style.transform = "scale(1.1)"}
            onMouseLeave={(e) => e.currentTarget.firstChild.style.transform = "scale(1)"}
          >
            <img src={instagramIcon} alt="Instagram" style={socialIconStyle} />
          </a>
          <a 
            href="https://twitter.com" 
            target="_blank" 
            rel="noopener noreferrer"
            onMouseEnter={(e) => e.currentTarget.firstChild.style.transform = "scale(1.1)"}
            onMouseLeave={(e) => e.currentTarget.firstChild.style.transform = "scale(1)"}
          >
            <img src={twitterIcon} alt="X (Twitter)" style={socialIconStyle} />
          </a>
          <a 
            href="https://facebook.com" 
            target="_blank" 
            rel="noopener noreferrer"
            onMouseEnter={(e) => e.currentTarget.firstChild.style.transform = "scale(1.1)"}
            onMouseLeave={(e) => e.currentTarget.firstChild.style.transform = "scale(1)"}
          >
            <img src={facebookIcon} alt="Facebook" style={socialIconStyle} />
          </a>
        </div>
      </div>
      
      {/* Copyright Area */}
      <div style={copyrightAreaStyle}>
        {/* Bottom border - full width */}
        <div style={bottomBorderStyle}></div>
        <div style={copyrightStyle}>
          © 2025 GIGIFY. All rights reserved
        </div>
      </div>
    </footer>
  );
};

export default MobileFooter;